import Vue from 'vue';
import axios from 'axios';

import { getToken, logout } from '@/utils/auth';
import store from '../store';

// 創建axios實例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  withCredentials: true,
  timeout: 500000, // 請求超時時間
});

const tokenExpire = (response) => {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const queryWenUsrid = params.get('wen_usrid');
  const queryWenStsid = params.get('wen_usrid');
  const hasLoginQuery = queryWenUsrid && queryWenStsid;
  if (hasLoginQuery) {
    logout();
    window.location.reload();
  } else {
    Vue.prototype.$swal
      .fire({
        icon: 'warning',
        title: response.data.message,
        showCancelButton: false,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      })
      .then(() => {
        logout();
        // window.location.replace(`${window.location.protocol }//${ window.location.hostname}`);
        // window.location.replace(`${window.location.origin}${process.env.VUE_APP_BASE_URL}Login`);
        // window.location.replace(`${(window.location.origin)}${this.$route.matched[0].path}/Login`);
        window.location.reload();
      });
  }
};

// 錯誤捕捉
const errorHandle = (status, msg, response) => {
  switch (status) {
  case 400:
    // console.log(response);
    break;
  case 401:
    tokenExpire(response);
    break;
  case 403:
    // console.log(response);
    break;
  case 404:
    // console.log(response);
    break;
  case 500:
    // console.log(response);
    break;
  default:
    // console.log(response);
    break;
  }
};

// 換頁時取消未完成的api
const { CancelToken } = axios;
let cancel;
let cancelToken;

function _uuid() {
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 || 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r && 0x3) || 0x8).toString(16);
  });
}

// request攔截器
service.interceptors.request.use(
  async (config) => {
    const token = getToken();
    token && (config.headers["X-Token"] = token); // eslint-disable-line
    cancelToken = new CancelToken((c) => {
      cancel = c;
    });
    config.cancelToken = cancelToken;
    config.uuid = _uuid();
    store.dispatch('config/addRequest', { cancel, ...config });
    store.dispatch('config/addLoading', { url: config.url, uuid: config.uuid });
    return config;
  },
  (error) => Promise.reject(error),
);

// respone攔截器
service.interceptors.response.use(
  (response) => {
    const res = response.data || '';
    if (res.result) {
      if (typeof res.result === 'object') {
        const firstIreKeyList = Object.keys(res.result) || '';
        if (Array.isArray(firstIreKeyList) && firstIreKeyList.length > 0) {
          firstIreKeyList.forEach((resultItemKey) => {
            res.result[resultItemKey] = typeof res.result[resultItemKey] === 'string' ? res.result[resultItemKey].trim() : res.result[resultItemKey];
          });
        }
      }
    }

    if (res instanceof Blob && response.status === 200) {
      store.dispatch('config/removeLoading', { url: response.config.url, uuid: response.config.uuid });
      store.dispatch('config/removeRequest', { uuid: response.config.uuid });
      return res;
    }
    if (res.code !== 200) {
      Vue.prototype.$swal.fire({
        icon: 'warning',
        html: res.message,
      });
    }
    // api回傳成功
    store.dispatch('config/removeLoading', { url: response.config.url, uuid: response.config.uuid });
    store.dispatch('config/removeRequest', { uuid: response.config.uuid });
    return res;
  },
  (error) => {
    // console.log('error', error);
    // FIXME: 這邊之後狀況要排除
    store.dispatch('config/removeLoading', { uuid: error.message.uuid });
    Vue.prototype.$swal.fire({
      icon: 'error',
      title: error,
      timer: 1500,
    });
    if (axios.isCancel(error)) {
      store.dispatch('config/removeLoading', { uuid: error.message.uuid });
      return new Promise(
        () => {},
        () => {},
      );
    }
    const { response } = error;
    if (response) {
      store.dispatch('config/removeLoading', { uuid: error.message.uuid });
      errorHandle(response.status, response.data.error, response);
    }
    return Promise.reject(error);
  },
);

export default service;
